import type { FC } from "react";

import { UIView, useCurrentStateAndParams } from "@uirouter/react";
import { ErrorBoundary } from "react-error-boundary";

import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";
import {
    BacklinksFrameContainer,
    BacklinksPageFrameWrapper,
} from "app/pages/digital-marketing/backlinks/frame/BacklinksFrameStyledComponents";
import { BacklinksSubNav } from "app/pages/digital-marketing/backlinks/frame/BacklinksSubNav";

export const BacklinksModuleFrame: FC = () => {
    const { state, params } = useCurrentStateAndParams();

    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            resetKeys={[state, params]}
        >
            <div className="sw-layout-module-inner">
                <BacklinksFrameContainer className="u-flex-row u-flex-column">
                    <div className="sw-layout-subnav">
                        <BacklinksSubNav />
                    </div>
                    <div className="sw-layout-scrollable-element sw-layout-research use-sticky-css-rendering">
                        <BacklinksPageFrameWrapper>
                            <UIView className="fadeIn" />
                        </BacklinksPageFrameWrapper>
                    </div>
                </BacklinksFrameContainer>
            </div>
        </ErrorBoundary>
    );
};
